<template>
  <div v-if="address">
    {{ formattedAddress() }}
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'CustomerAddresses',
  props: {
    address: {
      type: Object,
      default() {
        return {}
      },
    },
    filterAddress: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['formatAddress']),
  },
  methods: {
    formattedAddress() {
      return this.formatAddress(this.address, this.filterAddress)
    },
  },
}
</script>
